import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import Timer from "@/components/clockWork/timer.vue";
import BaseMixer from "../../BaseMixer";
import _ from "lodash";
import Swal from "sweetalert2";
import { IDayViewUserModeEntryWorkViewDTO } from "@/store/models/workView/dayViewUserModeEntryWorkView";
import { clearInterval, setInterval } from "worker-timers";
let DayViewUserEntryComponent = /** @class */ (() => {
    var _a;
    let DayViewUserEntryComponent = class DayViewUserEntryComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.liveTime = 0;
        }
        workviewTooltip(value) {
            if (value != null || value != "") {
                return value.length > 23 ? value : null;
            }
        }
        created() {
            this.interval = setInterval(() => {
                if (this.activeEntry) {
                    const istOffset = 5 * 60 + 30;
                    const endTimeInSeconds = this.activeEntry.endTime ? new Date(this.activeEntry.endTime).getTime() + istOffset * 60 * 1000 : Date.now();
                    const startTimeInSeconds = new Date(this.activeEntry.startTime).getTime() + istOffset * 60 * 1000;
                    this.liveTime = (endTimeInSeconds - startTimeInSeconds) / 1000;
                }
            }, 1000);
        }
        destroyed() {
            clearInterval(this.interval);
        }
        get checkingMNCO() {
            if (this.activeEntry == undefined) {
                return false;
            }
            else {
                const day = new Date();
                const toDay = day.getDate();
                const anyDay = new Date(this.activeEntry.dayEntryDate);
                var comonDay = anyDay.getDate();
                if (toDay != comonDay) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        get seconds() {
            return this.activeEntry.totalTimeInSeconds;
        }
        get clockWorkEntryId() {
            if (this.activeEntry.clockWorkEntryId != null) {
                clearInterval(this.interval);
            }
            else {
                clearInterval(this.interval);
            }
            return this.activeEntry.clockWorkEntryId;
        }
        getEntryTimeTitleMessage(startTime, endTime) {
            return startTime + " - " + endTime;
        }
        showProjectTitleMessage(projectString) {
            if (projectString == "Unassigned") {
                return "";
            }
            else {
                return projectString;
            }
        }
        showTaskTitleMessage(taskString) {
            if (taskString == "Unassigned") {
                return "";
            }
            else {
                return taskString;
            }
        }
        showActiveProjectTitleMessage(projectString) {
            if (projectString == "Unassigned") {
                return "";
            }
            else {
                return projectString;
            }
        }
        showActiveTaskTitleMessage(taskString) {
            if (taskString == "Unassigned") {
                return "";
            }
            else {
                return taskString;
            }
        }
        goToProjectOverView(projectId, isViewable) {
            if (projectId != null) {
                if (isViewable) {
                    this.$router.push({ name: "ProjectOverview", params: { projectId: projectId } });
                }
                else {
                    Swal.fire({
                        text: "Sorry! You do not have access to view this Project.",
                        icon: "warning",
                        confirmButtonColor: "#34c38f",
                        confirmButtonText: "Okay",
                    }).then(() => { });
                }
            }
        }
        get sortLiveViewUserModeEntries() {
            return _.orderBy(this.dayViewUserModeEntry.dayEntries, (item) => item.startTime, "desc");
        }
        get activeEntry() {
            return this.dayViewUserModeEntry.dayEntries.find((x) => x.endTime == null);
        }
        get isActive() {
            return this.activeEntry != null && this.activeEntry != undefined;
        }
        get entries() {
            return _.sortBy(this.dayViewUserModeEntry.dayEntries.filter((x) => x.endTime != null), "startTime").reverse();
        }
        get runningTime() {
            var runningTime = 0;
            runningTime = this.isActive ? this.liveTime : 0;
            return runningTime;
        }
        get totalTime() {
            var completedTime = _.sumBy(this.dayViewUserModeEntry.dayEntries.filter((x) => !this.activeEntry || x.clockWorkEntryId != this.activeEntry.clockWorkEntryId), "totalTimeInSeconds");
            return this.formattedTimeString(completedTime + this.runningTime);
        }
        get unassignedEntriesTime() {
            let unEntries = this.dayViewUserModeEntry.dayEntries.filter((x) => x.projectDisplayString == "Unassigned" && (!this.activeEntry || x.clockWorkEntryId != this.activeEntry.clockWorkEntryId));
            var completedTime = _.sumBy(unEntries, "totalTimeInSeconds");
            var currentRunTime = this.isActive && this.dayViewUserModeEntry.dayEntries.some((x) => x.projectDisplayString == "Unassigned" && x.clockWorkEntryId == this.activeEntry.clockWorkEntryId) ? this.runningTime : 0;
            return this.formattedTimeString(completedTime + currentRunTime);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDayViewUserModeEntryWorkViewDTO !== "undefined" && IDayViewUserModeEntryWorkViewDTO) === "function" ? _a : Object)
    ], DayViewUserEntryComponent.prototype, "dayViewUserModeEntry", void 0);
    DayViewUserEntryComponent = __decorate([
        Component({
            name: "DayViewUserEntryComponent",
            components: {
                Timer,
                simplebar,
            },
        })
    ], DayViewUserEntryComponent);
    return DayViewUserEntryComponent;
})();
export default DayViewUserEntryComponent;
